<div class="alternative-pagination">

    <div>
        <a class="paging-button"  [ngClass]="{ 'disabled':  ( page  == 0 || page == 1 ) }" (click)="goToFirst()">&laquo;</a>
    </div>

    <div>
        <a class="paging-button" [ngClass]="{ 'disabled':  ( page  == 0 || page == 1 ) }" (click)="goToPrev()">&lsaquo;</a>
    </div>

    <div>
        <input type="text" name="theNumber" [(ngModel)]="page" (change)="onKeyUp( $event )"  min="0" max="999999" pattern="\d*" inputmode="decimal"/>
    </div>

    <div>
        of
    </div>

    <div>
        {{pages}}
    </div>

    <div>
        <a class="paging-button"  [ngClass]="{ 'disabled':  ( page  >= pages  ) }" (click)="goToNext()">&rsaquo;</a>
    </div>

    <div>
        <a class="paging-button"  [ngClass]="{ 'disabled':  ( page  >= page ) }" (click)="goToLast()">&raquo;</a>
    </div>
</div>